import React, {useEffect, useState} from 'react';
import logo from './logo.svg';
import './App.css';
import { User } from 'oidc-client-ts';
import {
  Route,
  Routes,
  Link,
  useNavigate
} from "react-router-dom";
import { Iframe, IframeCallback, IframeLogin } from './Iframe';
import { PopupCallback } from './Popup';
import { LogoutCallback } from './Logout';
import { client, BASE_URL } from './oidc-settings';

function App() {
  const navigate = useNavigate();

  const [user, setUser] = useState<User | null>(null);
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (event.data.type && event.data.type === "oidc.user") {
        console.log("message received", event);
        client.getUser().then(function(user) {
          console.log("user", user);
          setUser(user);
          navigate("/");
        });
      }
    };
    window.addEventListener('message', handleMessage);
    client.getUser().then(function(user) {
      console.log("user", user);
      setUser(user);
    }).catch(function(err) {
      console.error(err);
    });
    return () => window.removeEventListener('message', handleMessage);
  }, [navigate]);

  const login = () => {
    client.signinPopup().then(function(user) {
      console.log("signed in", user);
      setUser(user);
    }).catch(function(err) {
      console.error(err);
    });
  }

  const logout = () => {
    client.signoutSilent({extraQueryParams: {redirect_to: `${BASE_URL}/logoutCallback`}}).then(function() {
      console.log("signed out");
      setUser(null);
    }).catch(function(err) {
      console.error(err);
    });
  }

  return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          { !user && <div>
            <LoginHint />
            <button onClick={login}>Login</button>
            <Link to="../iframe"><button>Login iframe</button></Link>
          </div> }
          <Routes>
            <Route path="/logoutCallback" element={<LogoutCallback />} />
            <Route path="/popupCallback" element={<PopupCallback />} />
            <Route path="/iframeCallback" element={<IframeCallback />} />
            <Route path="/iframeLogin" element={<IframeLogin />}/>
            <Route path="/iframe" element={<Iframe />}/>
            <Route path="/" element={ user && <LoggedIn user={user} logout={logout} />} />
          </Routes>
        </header>
      </div>
  );
}

const LoginHint = () => {
  const email = "john.kowalski@example.com";
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText(email).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  const hintStyle: React.CSSProperties = {
    fontSize: "0.5em",
    background: "#1a1a2e",
    border: "1px solid #444",
    borderRadius: "8px",
    padding: "12px 16px",
    marginBottom: "16px",
    textAlign: "left",
    lineHeight: 1.6,
  };

  const copyBtnStyle: React.CSSProperties = {
    fontSize: "0.85em",
    marginLeft: "6px",
    cursor: "pointer",
    background: "none",
    border: "1px solid #666",
    borderRadius: "4px",
    color: "#61dafb",
    padding: "1px 6px",
  };

  return (
    <div style={hintStyle}>
      <div>
        <b>Username:</b>{" "}
        <code>{email}</code>
        <button style={copyBtnStyle} onClick={copy}>
          {copied ? "Copied!" : "Copy"}
        </button>
      </div>
      <div>
        <b>Password:</b>{" "}
        <code>{email + email}</code>
      </div>
    </div>
  );
};

interface LoggedInProps {
  user: User;
  logout: () => void;
}

const LoggedIn = (props: LoggedInProps) => {
  const [hello, setHello] = useState("");
  const style: any = {fontSize: "0.4em", border: "solid thin white", padding: "5px", textAlign: "left", background: "black"}
  const callResourceServer = async () => {
    const url = "http://localhost:7777/hello";
    const token = props.user.access_token;
    try {
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });
      setHello(JSON.stringify(await resp.json(), null, 2));
    } catch (err) {
      setHello("Error: could not reach resource server at " + url);
    }
  }

  return (
    <div>
      <p>Logged in as {props.user.profile?.name}</p>
      <button onClick={props.logout}>Logout</button>
      <button onClick={callResourceServer}>Say Hello!</button>
      {hello && <pre style={style}>{hello}</pre>}
    </div>
  );
}

export default App;
